import headerModules from "./modules/headerModules";
import accordion from './modules/accordion';
import animation from './modules/animation';
import addTel from './modules/addTel';
import tabContent from './modules/tabContent';
// import smoothscroll from "./modules/smoothscroll";
import slider from './modules/slider';
// import pageTransition from './modules/pageTransition';
// import getInstagram from './modules/getInstagram';

document.addEventListener('DOMContentLoaded', () => {
  headerModules();
  accordion();
  addTel();
  tabContent();
});

window.addEventListener('load', () => {
  animation();
  slider();

  // smoothscroll();
  // slider();
  // getInstagram();
});
